
const setModalTitle = (state, payload) => {
  state.title = payload.title;
}

const setSVGType = (state, payload) => {
  state.svg_type = payload.svg_type;
}

const setModalMessage = (state, payload) => {
  state.message = payload.message;
}

const setModalVisible = (state, payload) => {
  state.visible = payload.visible;
}

export default {
  setModalTitle,
  setSVGType,
  setModalMessage,
  setModalVisible,
}